'use client';

import React from 'react';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { MobileSearchProvider } from '@eliadmin/core/src/components/header/mobile-search';
import { HeaderMenu } from './header-menu';
import { SearchButton } from '@eliadmin/core/src/components/header/search-button';
import { HeaderProfileButton } from '@eliadmin/core/src/components/header/header-profile-button';
import { HeaderFavoritesButton } from '@eliadmin/core/src/components/header/header-favorites-button';
import { HeaderCartButton } from '@eliadmin/core/src/components/header/header-cart-button';
import { LanguageSelect } from '@eliadmin/core/src/components/header/language-select';
import type {
  CategoriesEntity,
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';
import MobileSidebar from './mobile-sidebar';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { Logo } from '../ui/logo';

export type HeaderMainProps = {
  generalLayout: GeneralLayout['data'];
  categories: CategoriesEntity[];
  menu: Menu;
};

export function HeaderMain({ generalLayout, menu, categories }: HeaderMainProps) {
  const me = useCustomerStore(s => s.me);
  const isInicialized = useCustomerStore(s => s.isInitialized);

  const isAuthorited = me && me?.customer && isInicialized;

  return (
    <MobileSearchProvider>
      <div
        className={cn(
          'custom-container--xxl',
          'relative z-30 flex items-center justify-between bg-white p-4 sm:rounded-[4px] sm:p-6 md:p-7 xl:p-8',
          'ea-header-main',
        )}
      >
        <div className="hidden flex-1 items-center justify-start gap-6 lg:flex">
          <HeaderMenu menu={menu} categories={categories} />
        </div>
        <div className="flex items-center justify-start gap-4 lg:hidden">
          <MobileSidebar menu={menu.fields.slice(1)} />
          <Logo
            src={generalLayout?.header?.logo?.url ?? ''}
            alt={generalLayout?.contact?.company ?? ''}
            className={{ image: 'h-7 w-auto', link: 'hidden sm:flex' }}
          />
        </div>
        <Logo
          src={generalLayout?.header?.logo?.url ?? ''}
          alt={generalLayout?.contact?.company ?? ''}
          className={{
            image: 'h-5 w-auto sm:h-8 xl:h-9',
            link: 'max-w-[52vw] sm:hidden lg:flex lg:max-w-none',
          }}
        />
        <div className="hidden flex-1 items-center justify-end gap-3 sm:flex">
          <SearchButton />
          <HeaderProfileButton />
          <HeaderFavoritesButton />
          <HeaderCartButton />
          <LanguageSelect />
        </div>
        <div className="flex items-center justify-center sm:hidden">
          <SearchButton size={'none'} variant={'none'} />
        </div>
      </div>
    </MobileSearchProvider>
  );
}
